/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

//load REVIEW DYNAMICALLY
document.addEventListener('DOMContentLoaded', function () {
    // Function to extract and update WebwinkelKeur ratings
    function extractWebwinkelKeurRatings() {
        try {
            // Find the JSON-LD script containing WebwinkelKeur data
            const jsonLdScript = document.querySelectorAll('script[type="application/ld+json"]');
            jsonLdScript.forEach(script => {
                const jsonData = JSON.parse(script.textContent);
                
                // Check if the data contains the expected rating information
                if (jsonData.aggregateRating) {
                    const amount = jsonData.aggregateRating.reviewCount;
                    const rating = jsonData.aggregateRating.ratingValue.toFixed(1).replace('.', ',');
                    
                    // Update elements with the rating data
                    document.querySelectorAll('[data-rating-total]').forEach(el => el.innerHTML = amount);
                    document.querySelectorAll('[data-rating-average]').forEach(el => el.innerHTML = rating);

                    localStorage.setItem('ntljkp-rtotal', amount);
                    localStorage.setItem('ntljkp-raverage', rating);
                    
                    console.log('WebwinkelKeur ratings loaded from JSON-LD:', {
                        reviewCount: amount,
                        rating: rating
                    });
                }
            });
        } catch (error) {
            console.error('Error extracting WebwinkelKeur data:', error);
        }
    }

    // Check if the WebwinkelKeur data is already loaded
    if (window._webwinkelkeur_rich_snippet_loaded) {
        extractWebwinkelKeurRatings();
    } else {
        if (document.querySelector('.wwk-sidebar-popup_rating')) {
            document.querySelectorAll('[data-rating-average]').forEach(el => el.innerHTML = document.querySelector('.wwk-sidebar-popup_rating').innerHTML);
            document.querySelectorAll('[data-rating-total]').forEach(el => el.innerHTML = document.querySelector('.wwk-sidebar-popup__reviews_count').innerHTML.replace('(', '').replace(')', ''));
        }
            // Set up a watcher to check when the WebwinkelKeur data becomes available
        let checkInterval = setInterval(function() {
            if (window._webwinkelkeur_rich_snippet_loaded) {
                extractWebwinkelKeurRatings();
                clearInterval(checkInterval);
            }
        }, 100);
        
        // Set a timeout to stop checking after 10 seconds to prevent infinite checking
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 10000);
    }
});

// wwk-sidebar-popup_rating
// wwk-sidebar-popup__reviews_count

const observer = new MutationObserver(() => {
        const container = document.querySelector('.inject-quiz-banner');
        const container_second = document.querySelector('.inject-quiz-banner-b');
        const container_third = document.querySelector('.inject-quiz-banner-c');
        let section_id = null;
        let section = null;

        const handle_banner = document?.querySelector('.article_quiz_banner')?.dataset?.handle;

          if (!handle_banner) {
            console.error('Missing data-handle attribute on blog-product-section');
          }

        if (container || container_second || container_third) {
          observer.disconnect();
          if(container){section_id = 'blog-quiz-banner'; section = '.inject-quiz-banner';}
          else if(container_second){section_id = 'blog-quiz-banner-variant-b';section = '.inject-quiz-banner-b';}
          else if(container_third){section_id = 'blog-quiz-banner-variant-c';section = '.inject-quiz-banner-c';}
      
      

             fetch(`/blogs/${handle_banner}?section_id=${section_id}`)
              .then((response) => response.text())
              .then((responseText) => {
                
                const QuizViewhtml = new DOMParser().parseFromString(responseText, 'text/html')  ;
                const source = QuizViewhtml.querySelector('.js-inner-source');
                const source_second = QuizViewhtml.querySelector('.js-sidebar-quiz');
                document.querySelector(section).innerHTML = source.innerHTML;
                document.querySelector('.js-quiz-side-banner').innerHTML = source_second.innerHTML;
              });
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      
setTimeout(()=>{observer.disconnect();},5000);

// Integrate ConvertFlow cart updates with theme cart drawer
(function() {
  // Safety check: Only run if ConvertFlow is present or expected
  // This prevents the script from running unnecessarily
  if (typeof window.fetch === 'undefined') {
    console.warn('ConvertFlow cart integration: window.fetch not available');
    return;
  }
  
  // Listen for ConvertFlow cart updates
  // Store original fetch - check if it's already been wrapped
  const originalFetch = window.fetch.__originalFetch || window.fetch;
  let isConvertFlowCartUpdate = false;
  let isRefreshingCart = false;
  let refreshTimeout = null;
  let navigationPreventionActive = false;
  
  // Function to preserve ConvertFlow quiz state
  function preserveConvertFlowState() {
    const state = {
      currentStep: null,
      activeStep: null,
      quizData: null
    };
    
    // Try to get current step from ConvertFlow
    if (window.convertflow) {
      // Check for active step element
      const activeStep = document.querySelector('#cta_184003 .cf-step.cf-step-active, #cta_184003 .cf-step[data-active="true"]');
      if (activeStep) {
        state.activeStep = activeStep.getAttribute('data-step-id') || activeStep.id;
      }
      
      // Check for current step indicator
      const stepIndicator = document.querySelector('#cta_184003 .cf-step[data-current-step]');
      if (stepIndicator) {
        state.currentStep = stepIndicator.getAttribute('data-current-step');
      }
    }
    
    // Store in sessionStorage as backup
    try {
      sessionStorage.setItem('cf_quiz_state_backup', JSON.stringify(state));
    } catch(e) {
      // Ignore if sessionStorage not available
    }
    
    return state;
  }
  
  // Function to restore ConvertFlow quiz state
  function restoreConvertFlowState(state) {
    if (!state || !window.convertflow) return;
    
    // Try to restore from sessionStorage if state not provided
    if (!state.currentStep && !state.activeStep) {
      try {
        const saved = sessionStorage.getItem('cf_quiz_state_backup');
        if (saved) {
          state = JSON.parse(saved);
        }
      } catch(e) {
        return;
      }
    }
    
    // Restore active step if we have it
    if (state.activeStep) {
      // Wait a bit for cart drawer to finish opening
      setTimeout(() => {
        // Check if quiz is still on the results page (last step)
        const resultsSection = document.querySelector('#cta_184003 .cf-section.wc-quiz-result, #cta_184003 #section2309982');
        if (resultsSection && resultsSection.offsetParent !== null) {
          // Quiz is still on results page, good - no need to restore
          return;
        }
        
        // Quiz seems to have reset, try to restore
        const stepElement = document.querySelector(`#cta_184003 .cf-step[data-step-id="${state.activeStep}"], #cta_184003 #${state.activeStep}`);
        if (stepElement) {
          // Try various methods to restore the step
          if (window.convertflow && typeof window.convertflow.showStep === 'function') {
            try {
              window.convertflow.showStep(state.activeStep);
            } catch(e) {
              console.warn('Could not restore ConvertFlow step via showStep:', e);
            }
          }
          
          // Try clicking the step element to activate it
          if (stepElement.click) {
            try {
              stepElement.click();
            } catch(e) {
              // Ignore
            }
          }
          
          // Try dispatching custom event
          try {
            const event = new CustomEvent('cf:show-step', { detail: { stepId: state.activeStep } });
            document.dispatchEvent(event);
          } catch(e) {
            // Ignore
          }
        }
      }, 300);
    }
  }
  
  // Monitor for quiz resets and prevent them
  const quizObserver = new MutationObserver((mutations) => {
    // Check if quiz results section disappears (quiz reset)
    const resultsSection = document.querySelector('#cta_184003 .cf-section.wc-quiz-result, #cta_184003 #section2309982');
    if (!resultsSection || resultsSection.offsetParent === null) {
      // Results section is hidden, check if we need to restore
      try {
        const saved = sessionStorage.getItem('cf_quiz_state_backup');
        if (saved) {
          const state = JSON.parse(saved);
          if (state.activeStep) {
            // Only restore if we're not intentionally navigating away
            const cartDrawer = document.getElementById('mini-cart');
            if (cartDrawer && cartDrawer.hasAttribute('open')) {
              // Cart drawer is open, don't restore yet - wait for it to close
              return;
            }
          }
        }
      } catch(e) {
        // Ignore
      }
    }
  });
  
  // Start observing when DOM is ready
  if (document.body) {
    const quizContainer = document.querySelector('#cta_184003');
    if (quizContainer) {
      quizObserver.observe(quizContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-active', 'style']
      });
    }
  }
  
  // Prevent page reloads after cart updates from ConvertFlow
  let preventReload = false;
  const originalLocationReload = window.location.reload;
  const originalLocationAssign = window.location.assign;
  const originalLocationReplace = window.location.replace;
  
  // Store original location descriptor to intercept href assignments
  const locationDescriptor = Object.getOwnPropertyDescriptor(window, 'location') || 
                              Object.getOwnPropertyDescriptor(Object.getPrototypeOf(window), 'location');
  
  // // Intercept location changes that might cause reloads
  // // Use a more aggressive approach to prevent ALL reloads during cart refresh
  // const beforeUnloadHandler = function(e) {
  //   // Prevent ALL reloads if we're actively refreshing cart
  //   if (preventReload && (isRefreshingCart || navigationPreventionActive)) {
  //     e.preventDefault();
  //     e.stopImmediatePropagation();
  //     e.stopPropagation();
  //     console.log('[ConvertFlow Cart] Prevented page reload via beforeunload');
  //     return false;
  //   }
  // };
  
  // // Use capture phase to intercept before other handlers
  // window.addEventListener('beforeunload', beforeUnloadHandler, true);
  
  // Also intercept unload event
  window.addEventListener('unload', function(e) {
    if (preventReload && (isRefreshingCart || navigationPreventionActive)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      console.log('[ConvertFlow Cart] Prevented page unload');
    }
  }, true);
  
  // Override location methods temporarily during cart refresh
  let safeReload, safeAssign, safeReplace;
  
  function preventNavigation() {
    // Don't override if already active to prevent conflicts
    if (navigationPreventionActive) {
      return;
    }
    
    navigationPreventionActive = true;
    preventReload = true;
    
    // Store original methods if not already stored
    safeReload = function() {
      if (!isRefreshingCart && !navigationPreventionActive) {
        return originalLocationReload.apply(this, arguments);
      }
      console.log('[ConvertFlow Cart] Prevented page reload during cart refresh');
      return false;
    };
    
    safeAssign = function() {
      if (!isRefreshingCart && !navigationPreventionActive) {
        return originalLocationAssign.apply(this, arguments);
      }
      console.log('[ConvertFlow Cart] Prevented navigation (assign) during cart refresh');
      return false;
    };
    
    safeReplace = function() {
      if (!isRefreshingCart && !navigationPreventionActive) {
        return originalLocationReplace.apply(this, arguments);
      }
      console.log('[ConvertFlow Cart] Prevented navigation (replace) during cart refresh');
      return false;
    };
    
    // Override location methods
    try {
      if (window.location.reload === originalLocationReload || !window.location.reload.__isConvertFlowProtected) {
        window.location.reload = safeReload;
        window.location.reload.__isConvertFlowProtected = true;
      }
      if (window.location.assign === originalLocationAssign || !window.location.assign.__isConvertFlowProtected) {
        window.location.assign = safeAssign;
        window.location.assign.__isConvertFlowProtected = true;
      }
      if (window.location.replace === originalLocationReplace || !window.location.replace.__isConvertFlowProtected) {
        window.location.replace = safeReplace;
        window.location.replace.__isConvertFlowProtected = true;
      }
      
      // Note: window.location.href is non-configurable in browsers, so we can't intercept it directly
      // Instead, we rely on beforeunload/unload events and location method overrides which are working
      // If ConvertFlow uses location.href directly, the beforeunload handler will catch it
    } catch(e) {
      console.warn('[ConvertFlow Cart] Could not override location methods:', e);
    }
    
    // Restore after a longer delay to ensure cart refresh completes
    // Increased to 5 seconds to handle empty cart animations and ConvertFlow processing
    setTimeout(() => {
      try {
        if (window.location.reload === safeReload) {
          window.location.reload = originalLocationReload;
          delete window.location.reload.__isConvertFlowProtected;
        }
        if (window.location.assign === safeAssign) {
          window.location.assign = originalLocationAssign;
          delete window.location.assign.__isConvertFlowProtected;
        }
        if (window.location.replace === safeReplace) {
          window.location.replace = originalLocationReplace;
          delete window.location.replace.__isConvertFlowProtected;
        }
      } catch(e) {
        // Ignore restore errors
      }
      preventReload = false;
      navigationPreventionActive = false;
    }, 5000);
  }
  
  // Mark the fetch wrapper so other scripts can detect it
  const fetchWrapper = function(...args) {
    const url = args[0];
    let isAddOperation = false;
    let shouldPreventNavigation = false;
    
    // Check if this is a ConvertFlow cart update
    // Only intercept if it's coming from ConvertFlow and not on initial page load
    if (typeof url === 'string' && (url.includes('/cart/update.js') || url.includes('/cart/add.js'))) {
      // Check if it's coming from ConvertFlow
      try {
        const stack = new Error().stack;
        if (stack && (stack.includes('convertflow') || stack.includes('28636'))) {
          // Only process if document is fully loaded and not during initial page load
          // Also check that we're not in a loading state
          if (document.readyState === 'complete' || document.readyState === 'interactive') {
            // Additional safety: don't intercept if already refreshing
            if (!isRefreshingCart) {
              isConvertFlowCartUpdate = true;
              isAddOperation = url.includes('/cart/add.js');
              shouldPreventNavigation = true;
              
              // CRITICAL: Prevent navigation IMMEDIATELY, before fetch completes
              // This prevents ConvertFlow from triggering a reload before we can handle it
              preventNavigation();
            }
          }
        }
      } catch(e) {
        // If stack trace access fails, continue normally
        console.warn('[ConvertFlow Cart] Could not check stack trace:', e);
      }
    }
    
    // Always call original fetch, but handle response if it's a ConvertFlow update
    return originalFetch.apply(this, args).then(async response => {
      // If it's a ConvertFlow cart update, trigger theme cart refresh
      if (isConvertFlowCartUpdate && response.ok) {
        isConvertFlowCartUpdate = false;
        
        // Navigation prevention was already activated above, but ensure it's still active
        if (shouldPreventNavigation && !navigationPreventionActive) {
          preventNavigation();
        }
        
        // Ensure prevention is active before processing response
        // ConvertFlow might process the response synchronously, so we need prevention active NOW
        if (!navigationPreventionActive) {
          preventNavigation();
        }
        
        // Preserve ConvertFlow quiz state before opening cart drawer
        const quizState = preserveConvertFlowState();
        
        // Use originalFetch to avoid recursion and prevent page reloads
        originalFetch(`${window.themeVariables?.routes?.cartUrl || '/cart'}.js`)
          .then(async cartResponse => {
            const cartContent = await cartResponse.json();
            
            // Fetch cart drawer HTML section
            const miniCartElement = document.getElementById('mini-cart');
            const sectionId = miniCartElement?.getAttribute('section');
            
            if (sectionId) {
              originalFetch(`${window.themeVariables?.routes?.cartUrl || '/cart'}?section_id=${sectionId}`)
                .then(async sectionResponse => {
                  const sectionHtml = await sectionResponse.text();
                  
                  // Set sections in cartContent for theme to use
                  cartContent.sections = {
                    [sectionId]: sectionHtml
                  };
                  
                  // Dispatch theme cart events - use debounce to prevent double refresh
                  if (refreshTimeout) {
                    clearTimeout(refreshTimeout);
                  }
                  
                  if (isRefreshingCart) {
                    return; // Already refreshing, skip
                  }
                  
                  isRefreshingCart = true;
                  
                  // Update cart count and other UI elements immediately
                  document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                      cart: cartContent
                    }
                  }));
                  
                  // Debounce cart drawer refresh to prevent double refresh
                  // Only open drawer if it's an add operation, not an update
                  refreshTimeout = setTimeout(() => {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true,
                      cancelable: true,
                      detail: {
                        cart: cartContent,
                        openMiniCart: isAddOperation && window.themeVariables?.settings?.cartType === 'drawer'
                      }
                    }));
                    
                    // Reset flag after a delay to allow refresh to complete
                    // Longer delay for empty cart to handle animations
                    const delay = cartContent.item_count === 0 ? 2000 : 1000;
                    setTimeout(() => {
                      isRefreshingCart = false;
                    }, delay);
                    
                    // Restore ConvertFlow state after cart drawer opens
                    setTimeout(() => {
                      restoreConvertFlowState(quizState);
                    }, 500);
                  }, 100);
                })
                .catch(error => {
                  console.error('Error fetching cart section:', error);
                  // Fallback: just dispatch with cart data
                  if (refreshTimeout) {
                    clearTimeout(refreshTimeout);
                  }
                  
                  if (isRefreshingCart) {
                    return; // Already refreshing, skip
                  }
                  
                  isRefreshingCart = true;
                  
                  // Update cart count and other UI elements immediately
                  document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
                    bubbles: true,
                    cancelable: true,
                    detail: { cart: cartContent }
                  }));
                  
                  // Debounce cart drawer refresh to prevent double refresh
                  // Only open drawer if it's an add operation, not an update
                  refreshTimeout = setTimeout(() => {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true,
                      cancelable: true,
                      detail: { 
                        cart: cartContent,
                        openMiniCart: isAddOperation && window.themeVariables?.settings?.cartType === 'drawer'
                      }
                    }));
                    
                    // Reset flag after a delay to allow refresh to complete
                    // Longer delay for empty cart to handle animations
                    const delay = cartContent.item_count === 0 ? 2000 : 1000;
                    setTimeout(() => {
                      isRefreshingCart = false;
                    }, delay);
                    
                    // Restore ConvertFlow state
                    setTimeout(() => {
                      restoreConvertFlowState(quizState);
                    }, 500);
                  }, 100);
                });
            } else {
              // Fallback: dispatch events without section HTML
              if (refreshTimeout) {
                clearTimeout(refreshTimeout);
              }
              
              if (isRefreshingCart) {
                return; // Already refreshing, skip
              }
              
              isRefreshingCart = true;
              
              // Update cart count and other UI elements immediately
              document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                cancelable: true,
                detail: { cart: cartContent }
              }));
              
              // Debounce cart drawer refresh to prevent double refresh
              // Only open drawer if it's an add operation, not an update
              refreshTimeout = setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,
                  cancelable: true,
                  detail: { 
                    cart: cartContent,
                    openMiniCart: isAddOperation && window.themeVariables?.settings?.cartType === 'drawer'
                  }
                }));
                
                // Reset flag after a delay to allow refresh to complete
                setTimeout(() => {
                  isRefreshingCart = false;
                }, 1000);
                
                // Restore ConvertFlow state
                setTimeout(() => {
                  restoreConvertFlowState(quizState);
                }, 500);
              }, 100);
            }
          })
          .catch(error => {
            console.error('Error refreshing cart after ConvertFlow update:', error);
            isRefreshingCart = false;
          });
      }
      
      // Return the original response, not the cloned one, to prevent reload issues
      return response;
    }).catch(error => {
      // If there's an error, reset flags and rethrow
      isConvertFlowCartUpdate = false;
      isRefreshingCart = false;
      throw error;
    });
  };
  
  // Mark the wrapper so it can be detected by other scripts if needed
  fetchWrapper.__originalFetch = originalFetch;
  fetchWrapper.__isConvertFlowWrapper = true;
  
  // Only override if fetch hasn't been wrapped by another script
  // Check if there's already a wrapper
  if (window.fetch.__isConvertFlowWrapper) {
    console.warn('[ConvertFlow Cart] Fetch already wrapped, skipping override');
  } else {
    window.fetch = fetchWrapper;
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const containers = document.querySelectorAll(".block-product-section");
    if (containers.length > 0) {
      containers.forEach((container) => {
        if (container.dataset.processed) return;
        const productId = container.getAttribute("data-product-id");
        container.dataset.processed = true;

        if (productId === "1") {
          fetch("/?sections=new-blog-product", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              const sectionHtml = data["new-blog-product"];
              if (sectionHtml) {
                const parser = new DOMParser();
                const quickViewHtml = parser.parseFromString(
                  sectionHtml,
                  "text/html"
                );
                const source = quickViewHtml.querySelector(".feature-product");
                if (source) {
                  container.innerHTML = source.innerHTML;
                }
              }
            })
            .catch((error) => {
              console.error("Error loading product 1:", error);
            });
        } else if (productId === "2") {
          fetch("/?sections=new-blog-product-two", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              const sectionHtml = data["new-blog-product-two"];
              if (sectionHtml) {
                const parser = new DOMParser();
                const quickViewHtml = parser.parseFromString(
                  sectionHtml,
                  "text/html"
                );
                const source = quickViewHtml.querySelector(".feature-product");
                if (source) {
                  container.innerHTML = source.innerHTML;
                }
              }
            })
            .catch((error) => {
              console.error("Error loading product 2:", error);
            });
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    observer.disconnect();
  }, 5000);
});


class CartRecommendedSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  destroySwiper() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');

          this.swiperInstance = null;

          return null;
        }

        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);

        this.swiperInstance = null; // Fallback
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper('.cart-recommendation-mobile', {
      slidesPerView: 1.26,
      spaceBetween: 24,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('cart-recommended-swiper', CartRecommendedSwiper);

class CartReviewWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const storedRTotal = localStorage.getItem('ntljkp-rtotal');
    const storedRAverage = localStorage.getItem('ntljkp-raverage');

    document.getElementById('mini-cart-average').innerHTML = storedRAverage;
    document.getElementById(
      'mini-cart-total-id'
    ).innerHTML = `(${storedRTotal})`;
  }
}

customElements.define('cart-review-widget', CartReviewWidget);